import { paths } from '@mc/paths'

// https://app.growthbook.io/features/pen-7694_v1
export const PROMO_STICKY_FOOTER_GIFT_CTA_FLAG_NAME = 'pen-7694_v1'

export const STICKY_FOOTER_GIFT_CTA_HREF = `${paths.promotion}?entry_source=sticky_footer_gift`
